/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

const intervalId = setInterval(() => {
  // Use a timeout to add a delay within the interval execution
  setTimeout(() => {
    // Find the last child of the upsell block
    const lastAccordionBody = $('.product__block.product__block--accordion.product__block--accordion-clear')
      .last()
      .find('.accordion__content');

    // Check if the target element exists before appending
    if (lastAccordionBody.length) {
      // Find the .product__block.product__upsell element
      const upsellBlock = $('.product__block.product__upsell');

      // Append the upsellBlock to lastAccordionBody
      if (upsellBlock.length) {
        lastAccordionBody.append(upsellBlock);

        // Clear the interval once appended
        clearInterval(intervalId);
      } else {
        console.error('The target element .product__block.product__upsell was not found.');
      }
    } else {
      console.error('The target element .accordion__body.rte was not found.');
    }
  }, 500); // Timeout delay of 500ms
}, 1000); // Interval execution every 1 second

// Product Accodian

const accordions = document.querySelectorAll('.product__content .accordion');

accordions.forEach(acc => {
  acc.addEventListener('click', function () {
    // Close all other accordions
    accordions.forEach(otherAcc => {
      if (otherAcc !== acc) {
        otherAcc.removeAttribute('open');
      }
    });
  });
});


// Swatch Carat Weight

document.addEventListener('DOMContentLoaded', function () {



  const tabs = document.querySelectorAll('.carat-tab');
  const images = document.querySelectorAll('.carat-image');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      // Remove active class from all tabs
      tabs.forEach((t) => t.classList.remove('active'));

      // Add active class to the clicked tab
      tab.classList.add('active');

      // Hide all images
      images.forEach((img) => (img.style.display = 'none'));

      // Show the image corresponding to the clicked tab
      const caratWeight = tab.getAttribute('data-carat-weight');
      const imageToShow = document.querySelector(`.carat-image[data-carat-weight="${caratWeight}"]`);
      if (imageToShow) {
        imageToShow.style.display = 'block';
      }
    });
  });

  // Optionally, activate the first tab and image by default
  if (tabs.length > 0) {
    tabs[0].classList.add('active');
    const firstImage = images[0];
    if (firstImage) {
      firstImage.style.display = 'block';
    }
  }

  // Carat Weight active

  document.addEventListener('click', function (event) {
    if (event.target.closest('div[option-name="Carat Weight"] .swatch-button')) {
      const dataValue = event.target.closest('.swatch-button').getAttribute('data-value');


      // Set dataValue in #carat-number element
      const caratNumberElement = document.getElementById('carat-number');
      if (caratNumberElement) {
        caratNumberElement.textContent = dataValue; // Update the content
      }

      // Click matching .carat-tab element
      document.querySelectorAll('.carat-weight-options .carat-tab').forEach(li => {
        if (li.getAttribute('data-carat-weight') === dataValue) {
          li.click();
        }
      });
    }
  });


  document.addEventListener('click', function (event) {
    if (event.target.closest('.carat-tab')) {
      const dataCaratWeight = event.target.closest('.carat-tab').getAttribute('data-carat-weight');
      const goldPercentage = event.target.closest('.carat-tab').getAttribute('gold-percentage');

      console.log(goldPercentage);

      document.querySelectorAll('.swatch-button').forEach(button => {
        if (button.getAttribute('data-value') === dataCaratWeight) {
          button.click();
        }
      });
    }
  });



});

// window.onload = function () {
//   setTimeout(function () {
//     // Ensure the swatch container is loaded before attempting the click
//     const swatchContainer = document.querySelector('div[option-name="Jewelry material"]');

//     if (swatchContainer) {
//       // Find the first swatch item inside the container
//       const firstSwatchItem = swatchContainer.querySelector('.swatch-view-item:first-child');

//       if (firstSwatchItem) {
//         // Simulate a click on the first swatch item
//         firstSwatchItem.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));

//         // Optionally alert for testing
//         // alert('variant click triggered before loading complete');
//       } else {
//         console.error('No swatch-view-item found as the first child.');
//       }
//     } else {
//       console.error('Swatch container with option-name="Jewelry material" not found.');
//     }
//   }, 0); // Delay the click by 0 milliseconds to allow DOM parsing
// };


// varriant images updated

document.addEventListener('DOMContentLoaded', function () {
  // Function to initialize the swatch click logic


  document.addEventListener('click', function (event) {
    // Check if the clicked element is within a jewelry material swatch
    const swatchItem = event.target.closest('div[option-name="Jewelry material"] .swatch-view-item');
    if (swatchItem) {
      const colorValue = swatchItem.getAttribute('orig-value');

      const productSlides = document.querySelectorAll('.product__slide');

      productSlides.forEach(slide => {
        const imageValue = slide.getAttribute('data-media-alt');

        if (imageValue === colorValue) {
          slide.style.display = 'block';
        } else {
          slide.style.display = 'none';
        }
      });

      console.log('Selected Color:', colorValue);
    }
  });
});




document.getElementById('rebuy-cart-close').addEventListener('click', function () {
  alert('click');
  const observer = new MutationObserver(() => {
    document.body.removeAttribute('style');
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

  // Stop observing after 1 second (or your preferred duration)
  setTimeout(() => observer.disconnect(), 1000);
});














